export const GET_CMS_PAGE_REQUEST = "GET_CMS_PAGE_REQUEST"
export const GET_CMS_PAGE_SUCCESS = "GET_CMS_PAGE_SUCCESS"
export const GET_CMS_PAGE_FAILED = "GET_CMS_PAGE_FAILED"